<template>
  <div class="main">
    <div
      class="header"
      :style="{
        'background-color': '#2187FF',
      }"
    >
      <span
        style="
          font-size: 18px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          width: 1704px;
          margin: 0 auto;
        "
        >HI,欢迎来到河南省
        {{
          deptName +
          (cityDetail.homeTitle
            ? cityDetail.homeTitle
            : "农村集体财产监督管理平台")
        }}！</span
      >
    </div>
    <div
      class="container"
      :style="{
        background: cityDetail.loginImg
          ? `url('${cityDetail.loginImg}') no-repeat`
          : `url('${require('../assets/img/loginbackground.png')}') no-repeat`,
        'background-size': '100% 100%',
      }"
    >
      <div
        style="
          width: 80%;
          margin: auto;
          height: 100%;
          display: flex;
          justify-content: space-between;
        "
      >
        <div class="left">
          <span class="titleImg">
            {{
              cityDetail.homeTitle
                ? cityDetail.cityName + cityDetail.homeTitle
                : cityDetail.cityName + "农村集体财产监督管理平台"
            }}</span
          >
          <div class="input">
            <div class="typeDiv">
              <span @click="changeType(1)" :class="type == 1 ? 'span' : ''"
                >找资讯</span
              >
              <span style="width: 4px">|</span>
              <span @click="changeType(2)" :class="type == 2 ? 'span' : ''"
                >找项目</span
              >
            </div>
            <input
              type="text"
              placeholder="请输入关键字..."
              style="
                height: 50px;
                width: 58%;
                font-size: 18px;
                line-height: 50px;
              "
              v-model="keyword"
              @keyup.enter="toQuanzhan()"
            />
            <img
              src="../assets/img/loginSearch.png"
              style="height: 100%"
              @click="toQuanzhan"
            />
          </div>
          <div class="options">
            <span style="color: #ffffff; font-size: 18px; font-weight: 500"
              >热门搜索:</span
            >
            <span class="option" @click="searchkey('公示公告')">公示公告</span>
            <span class="option" @click="searchkey('交易项目')">交易项目</span>
            <span class="option" @click="searchkey('交易金额')">交易金额</span>
            <span class="option" @click="searchkey('报名须知')">报名须知</span>
          </div>
        </div>
        <div class="right">
          <div
            style="text-align: center; width: 100%; height: 74px"
            :style="{
              'background-color': '#2187FF',
            }"
          >
            <span
              style="
                font-size: 30px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #ffffff;
                line-height: 74px;
              "
              >个人用户注册</span
            >
          </div>
          <div class="loginWindow">
            <div class="registerInput">
              <img
                src="../assets/img/loginusername.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                type="text"
                placeholder="请输入用户名"
                style="flex: 1; font-size: 20px"
                v-model="userName"
              />
            </div>
            <div class="registerInput">
              <img
                src="../assets/img/loginusername.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                type="text"
                placeholder="请输入真实姓名"
                style="flex: 1; font-size: 20px"
                v-model="nickName"
              />
            </div>
            <div class="registerInput">
              <img
                src="../assets/img/loginusername.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                type="text"
                placeholder="请输入身份证号"
                style="flex: 1; font-size: 20px"
                v-model="idCard"
              />
            </div>
            <div class="registerInput">
              <img
                src="../assets/img/loginphone.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                type="text"
                placeholder="请输入手机号"
                style="flex: 1; font-size: 20px; width: 100%"
                v-model="phonenumber"
              />
              <el-button
                type="primary"
                style="padding: 8px 6px"
                @click="getPhoneCode"
                :disabled="loginSec != 0"
                >获取验证码<span v-if="loginSec != 0"
                  >({{ loginSec }})</span
                ></el-button
              >
            </div>
            <div class="registerInput">
              <img
                src="../assets/img/loginphone.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                type="text"
                placeholder="请输入验证码"
                style="flex: 1; font-size: 20px; width: 100%"
                v-model="code"
              />
            </div>
            <div class="registerInput">
              <img
                src="../assets/img/loginpassword.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                :type="showPassword ? 'text' : 'password'"
                placeholder="请输入登录密码"
                style="flex: 1; font-size: 20px; width: 100%"
                v-model="newpassword"
              />
              <img
                v-if="showPassword"
                src="../assets/img/closeEye.png"
                style="width: 20px; cursor: pointer; margin-left: 6px"
                @click="showPassword = !showPassword"
              />
              <img
                v-else
                src="../assets/img/openEye.png"
                alt=""
                style="width: 20px; cursor: pointer; margin-left: 6px"
                @click="showPassword = !showPassword"
              />
            </div>
            <div class="registerInput">
              <img
                src="../assets/img/loginpassword.png"
                style="width: 24px; height: 24px; margin-right: 16px"
              />
              <input
                :type="showAgainPassword ? 'text' : 'password'"
                placeholder="请再次输入登录密码"
                style="flex: 1; font-size: 20px"
                v-model="twovnewpassword"
              />
              <img
                v-if="showAgainPassword"
                src="../assets/img/closeEye.png"
                style="width: 20px; cursor: pointer; margin-left: 6px"
                @click="showAgainPassword = !showAgainPassword"
              />
              <img
                v-else
                src="../assets/img/openEye.png"
                alt=""
                style="width: 20px; cursor: pointer; margin-left: 6px"
                @click="showAgainPassword = !showAgainPassword"
              />
            </div>
            <div style="margin-bottom: 14px; display: flex">
              <el-checkbox v-model="checked">
                <span
                  style="
                    font-size: 18px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #000;
                  "
                  >我已同意</span
                >
                <!-- <router-link ></router-link> -->
                <span
                  style="
                    font-size: 18px;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #2187ff;
                  "
                  @click.prevent="isShow = true"
                  >《注册协议》</span
                >
              </el-checkbox>
            </div>
            <div
              style="
                width: 100%;
                height: 60px;
                justify-content: center;
                display: flex;
                margin-bottom: 14px;
                cursor: pointer;
              "
              :style="{
                'background-color': '#2187FF',
              }"
              @click="toregister"
            >
              <span
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                  font-weight: 500;
                  color: #ffffff;
                  line-height: 60px;
                  margin-bottom: 56px;
                  user-select: none;
                "
                >注 册</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <router-link
                to="/"
                style="
                  font-size: 16px;
                  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                  font-weight: 500;
                  color: #8896b3;
                "
                v-if="cityDetail.homeShowLogin"
                >已有账号，直接登录</router-link
              >
              <router-link
                :to="{ name: '登录', query: { path: 'register' } }"
                style="
                  font-size: 16px;
                  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                  font-weight: 500;
                  color: #8896b3;
                "
                v-else
                >已有账号，直接登录</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <yqlj></yqlj> -->
    <Foot />
    <el-dialog :visible.sync="isShow" width="1300px" center>
      <div class="msg">
        <p>
          本单位自愿加入“
          {{
            cityDetail.homeTitle
              ? cityDetail.cityName + cityDetail.homeTitle
              : cityDetail.cityName + "农村集体财产监督管理平台"
          }}用户信息库”，信息库登记的相关信息均经本单位核准确认无误，对此郑重承诺如下：
        </p>
        <p>
          一、本单位提交并在数据库发布的相关信息均真实有效，提交的材料无任何伪造、修改、虚假成份，材料所述内容均为我单位真实拥有。若违反本承诺一经查实，本单位愿意接受公开通报，自愿退出所有
          {{
            cityDetail.homeTitle
              ? cityDetail.cityName + cityDetail.homeTitle
              : cityDetail.cityName + "农村集体财产监督管理平台"
          }}正在进行的投标项目并取消注册资格，按照《中华人民共和国招标投标法》第五十四条和《中华人民共和国政府采购法》第七十七条的规定，禁止三年内进入招标采购市场。
        </p>
        <p>
          二、凡我单位在
          {{
            cityDetail.homeTitle
              ? cityDetail.cityName + cityDetail.homeTitle
              : cityDetail.cityName + "农村集体财产监督管理平台"
          }}参加的投标项目，在资格审查和评标阶段需要提交的企业业绩和获奖情况等，应依照相关规定事先在主管部门官方媒体上对外发布，未按规定发布的可不作为本单位资格审查和评标的依据。
        </p>
        <p>
          三、本单位在参加
          {{
            cityDetail.homeTitle
              ? cityDetail.cityName + cityDetail.homeTitle
              : cityDetail.cityName + "农村集体财产监督管理平台"
          }}项目投标过程中严格遵守各项廉政制度，如有违反自愿按规定接受处罚。
        </p>
        <p>
          四、本单位在参加
          {{
            cityDetail.homeTitle
              ? cityDetail.cityName + cityDetail.homeTitle
              : cityDetail.cityName + "农村集体财产监督管理平台"
          }}项目投标过程中如有违反《最高人民检察院关于行贿犯罪档案查询工作暂行规定》、《最高人民法院关于公布失信被执行人名单信息的若干规定》或被列入失信企业名单，我单位应该事先声明，否则造成的一切后果由本单位自行承担。
        </p>
        <p>
          五、系统数据是保障电子化开评标的关键，本单位将认真、及时的维护和更新会员数据库中的相关资料信息，若未能及时维护和更新，将自愿承担由此造成的一切不良后果。
        </p>
        <p>
          六、若违反本承诺一经查实，本单位愿接受
          {{
            cityDetail.homeTitle
              ? cityDetail.cityName + cityDetail.homeTitle
              : cityDetail.cityName + "农村集体财产监督管理平台"
          }}依据有关法律、法规给予的处罚。
        </p>
        <div style="text-align: center">
          <el-button type="primary" class="checkbox" @click="agreecheng"
            >同意</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import yqlj from '@/components/Home/Third/友情链接1.vue'
import Foot from '@/components/Foot.vue'
import { getPhoneCode, register } from '../api/login.js'
import IdCard from "../util/idCard.js"
import { cityDetail } from '../util/mainOption.js'

export default {
  components: {
    yqlj,
    Foot,
  },
  data () {
    return {
      phonenumber: '',
      code: "",
      newpassword: '',
      twovnewpassword: '',
      idCard: '',
      // email: '',
      checked: false,
      keyword: '',
      type: 1,
      isShow: false,
      userName: '',
      showAgainPassword: false,
      showPassword: false,
      loginSec: 0,
      uuid: "",
      deptName: "",
      nickName: "",
    }
  },
  methods: {
    getPhoneCode () {
      getPhoneCode(this.phonenumber)
        .then((res) => {
          this.$message.success(res.data.msg)
          this.uuid = res.data.uuid
          this.loginSec = 60
          let timer = setInterval(() => {
            if (this.loginSec == 0) {
              clearInterval(timer)
            } else {
              this.loginSec--
            }

          }, 1000)
        })
        .catch((err) => {
        })
    },
    agreecheng () {
      this.checked = true
      this.isShow = false
    },
    changeType (i) {
      this.type = i
    },
    toQuanzhan () {
      if (this.keyword.trim() != '') {
        this.$router.push({
          name: '全站搜索',
          query: { keyword: this.keyword, type: this.type },
        })
      } else {
        this.$message.error('查询关键字不可为空')
      }
    },
    searchkey (key) {
      this.$router.push({ name: '全站搜索', query: { keyword: key, type: 1 } })
    },
    toregister () {
      let passwordTest = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z.!,./;'":+-/=*&^%$#@]{6,16}$/

      if (
        !/^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(
          this.phonenumber
        )
      ) {
        this.$message.error('输入的手机号有误')
      } else if (this.code.trim() == '') {
        this.$message.error('输入的验证码不可为空')
      } else if (this.newpassword.trim() == '') {
        this.$message.error('输入的密码不可为空')
      } else if (!passwordTest.test(this.newpassword)) {
        this.$message.error('输入的密码最少为6位，最多为16位，且不能为纯数字')
      } else if (this.newpassword != this.twovnewpassword) {
        this.$message.error('两次输入的密码不一致')
      } else if (this.idCard.trim() == '') {
        this.$message.error('身份证号不可为空')
      } else if (!IdCard.cnid(this.idCard)) {
        this.$message.error('请输入正确的身份证号')
      } else if (this.userName.trim() == '') {
        this.$message.error('姓名不可为空')
      } else if (this.checked == false) {
        this.$message.error('请勾选我已同意《注册协议》')
      } else {
        register({
          password: this.newpassword,
          phoneNumber: this.phonenumber,
          // email: this.email,
          idCard: this.idCard,
          areaId: cityDetail.lesseeId,
          userName: this.userName,
          uuid: this.uuid,
          phoneCode: this.code,
          nickName: this.nickName
        }).then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            this.$message.success('注册成功!')
            // this.$router.push('/login');
            if (cityDetail.homeShowLogin) {
              this.$router.push("/")
            } else {
              this.$router.push({ name: '登录', query: { path: 'register' } })
            }
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
  },
  mounted () {
    this.deptName = cityDetail.toCityChangeTitle ? (sessionStorage.getItem("deptName") ? sessionStorage.getItem("deptName") : cityDetail.cityName) : cityDetail.cityName
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

input {
  border: none;
  outline: none;
}

.main {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  height: 52px;
  zoom: 1.2;
  box-sizing: border-box;
  padding-left: 240px;
}

.container {
  width: 100%;
  background-size: 100% 100%;
  height: 946px !important;
  zoom: 1.1;
}

.left {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  margin-left: 140px;
  zoom: 1.2;
}

.titleImg {
  font-family: Source Han Sans;
  font-size: 50px;
  color: #fff;
  font-weight: bold;
  margin-bottom: 24px;
  text-shadow: 1px 1px 1px #919191, 1px 2px 1px #919191, 1px 3px 1px #919191,
    1px 4px 1px #919191, 1px 5px 1px #919191, 1px 12px 6px rgba(10, 10, 10, 0.4),
    1px 14px 6px rgba(10, 10, 10, 0.2), 1px 16px 10px rgba(10, 10, 10, 0.2),
    1px 18px 35px rgba(10, 10, 10, 0.2), 1px 20px 60px rgba(10, 10, 10, 0.2);
}
.registerInput {
  background-color: #ffffff;
  padding: 10px 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  border: 1px solid #c0c4cc;
  margin-bottom: 14px;
}
.input {
  display: flex;
  align-items: center;
  background-color: #fff;
  width: 699.5px;
  padding-right: 0;
  border-radius: 5px;
  box-sizing: border-box;
}

.options {
  display: flex;
  align-items: center;
  height: 24px;
}

.option {
  margin-left: 20px;
  font-size: 18px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
}

.right {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 460px;
  zoom: 1.2;
  justify-content: center;
}

.loginWindow {
  background: url("../assets/img/loginfog.png") no-repeat;
  width: 100%;
  background-size: 100% 100%;
  padding: 30px 40px;
}

.typeDiv {
  width: 200px;
  height: 50px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
}

.typeDiv span {
  font-size: 20px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #3c3c3c;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.typeDiv .span {
  font-size: 20px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #2187ff;
  cursor: pointer;
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.msg p {
  text-indent: 2em;
  font-size: 24px;
}

.checkbox {
  margin-top: 20px;
  transform: scale(1.75);
}
</style>
